import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";


export default function HideConfirmModal({open, setOpen, onConfirm}){

    const handleConfirm = () =>{
        onConfirm();
        setOpen(false);
    }

    return (
        <Modal
            show={open}
            onClose={() => setOpen(false)}
            closeOnBlur
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Confirm Hide</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                fullwidth
                                onClick={handleConfirm}
                            >
                                Confirm
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )



}